/**
 * 全域使用的共檢查用函示
 */
import defaultTo from 'lodash/defaultTo'

/**
 * 判斷是否為數字
 * @param value
 * @returns {boolean}
 */
export function isNumber(value) {
  if (typeof value === 'undefined') return false
  const re = /^[0-9]+$/ // 是否為數字
  value = String(value).trim()
  return re.test(Number(value)) && value !== ''
}

/**
 * 判斷是否為浮點數
 * @param value
 * @returns {boolean}
 */
export function isFloat(value) {
  if (typeof value === 'undefined') return false
  const re = /^-?\d*\.\d+$/ // 是否為浮點數
  value = String(value).trim()
  return re.test(Number(value)) && value !== ''
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 是否存在
 * @param {string} path
 * @returns {Boolean}
 */
export function isSet(value) {
  return defaultTo(value, false)
}

/**
 * 是否 tg game
 */
export function isTgGame() {
  return localStorage.getItem('tggame') === '1'
}

/**
 * 是否有設定mode
 */
export function isDemoLink() {
  return localStorage.getItem('mode') === 'demoLink'
}

/**
 * 是否有設定mode
 */
export function isNewGame() {
  return localStorage.getItem('mode') === 'newgame'
}

/**
 * 是否為手機裝置
 * @returns {RegExpMatchArray}
 */
export function isMobile() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

/**
 * 是否另開新頁
 */
export function isWindowOpen() {
  const extra = localStorage.getItem('extra')
  let is2010 = false
  if (extra) {
    is2010 = extra.split(',').includes('2010') // 2010 就不另開視窗 使用原本的視窗 跳轉網址
  }
  return ( !isMobile() && !isTgGame() && !isNewGame() && !is2010)
}
